import Immutable from 'immutable';
import {
  DROPDOWN_MENU_OPEN,
  DROPDOWN_MENU_CLOSE,
} from '../actions/dropdown_menu';

const initialState = Immutable.Map({ openId: null, placement: null });

export default function dropdownMenu(state = initialState, action) {
  switch (action.type) {
  case DROPDOWN_MENU_OPEN:
    return state.merge({ openId: action.id, placement: action.placement });
  case DROPDOWN_MENU_CLOSE:
    return state.get('openId') === action.id ? state.set('openId', null) : state;
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/mastodon/reducers/dropdown_menu.js